import template from './query-select-path.html';
import './query-select-path.scss';

export default {
	template,
	bindings: {
		path: '<',
	},
};
